import styled from 'styled-components';

export const Icon = styled.i`
  margin-left: ${props => (props.ml ? props.ml : '30px')};

  transform: scale(1.4);
  > svg {
    fill: black;
  }
`;

export const BrandsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;
